svg.searchIcon {
	height: 24px;
	width: 24px;
	color: #737373;
}

svg.clearIcon {
	height: 21px;
	width: 20px;
	color: #949494;
}

.searchFieldWrapper {
	display: flex;
	flex-direction: row;
	gap: 10px;
	flex: 1 1 0;
	align-items: baseline;
	justify-content: center;
	margin: 0;
}

.corePaperWrapper {
	display: flex;
	flex-wrap: wrap;
	flex-direction: row;
	gap: 10px;
	align-items: center;
	justify-content: center;
	padding: 20px 40px;
	width: 100%;
}

@media (max-width: 600px) {
	.corePaperWrapper {
		gap: 5px;
		padding: 20px;
	}
}
